module.exports = __webpack_public_path__ + "static/tiamat-0dd79cc9c9db8d32fd5b65f9a13ed1bb.webp";